import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Button } from '@mui/material';
import React from 'react';
import { useIsDesktop } from '../../utils/mediaQueries';
import buttonStyle from './style';
export const ActionButton = ({ type = 'primary', onClick, text, disabled, sectionName, buttonType, buttonClickText, clickUrl, }) => {
    const currentPillarName = window.location.href.split('/')[3] || ' ';
    const isDesktop = useIsDesktop();
    const gaCTAAttributes = {
        'data-navigation-name': currentPillarName == 'goalsetting'
            ? 'Goals'
            : currentPillarName[0].toUpperCase() + currentPillarName.slice(1),
        'data-section-name': sectionName,
        'data-section-id': sectionName,
        'data-insight-id': 'Not applicable',
        'data-click-text': text,
        'data-type': 'CTA',
        click_url: clickUrl,
    };
    const gaButtonAttributes = {
        'data-navigation-name': currentPillarName == 'goalsetting'
            ? 'Goals'
            : currentPillarName[0].toUpperCase() + currentPillarName.slice(1),
        'data-section-name': sectionName,
        'data-section-id': sectionName,
        'data-insight-id': 'Not applicable',
        'data-click-text': buttonClickText,
        'data-type': buttonType,
        'data-click-action': buttonClickText,
    };
    return (_jsx(_Fragment, { children: _jsx(Button, { sx: { ...buttonStyle[type], fontSize: `${isDesktop ? '1' : '0.875'}rem` }, onClick: onClick, disabled: disabled, ...(buttonType == 'Button' ? { ...gaButtonAttributes } : { ...gaCTAAttributes }), children: text }) }));
};
